//@ts-nocheck
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Timeline from '@mui/lab/Timeline';
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, Grid } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { stringAvatar } from 'utils/functions';
import { FileDocumentIcon } from 'component/commonComponents/Icon';
import PropTypes from "prop-types";
import React from "react";
import Typography from '../../commonComponents/Typography/index';
import { StyledTimeLineSection } from "./timeLine.style";
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import { useTheme } from 'styled-components';

export interface ITimeLineProps {
  data: any,
  isLoading?: boolean,
  createdDateInit: any,
  currentUser: any,
  locale: any,
};

let key = 0;

const TimeLine = (props: ITimeLineProps) => {
  const { data, isLoading, createdDateInit, currentUser, locale } = props;
  const theme = useTheme() as typeof DefaultUptimeTheme;
  const showTimeLine = (list: any) => {
    let result = null;
    const listType = [...list.map((item: any) => item.type), 'state'];

    result = list.map((item: any, index: any) => {
      let isCheckLastDotItem = (['comments', 'attachments'].includes(list[index].type) &&  ['state'].includes(listType[index + 1])) ? true : false;
      let isCheckFirstDotItem = (['comments', 'attachments'].includes(list[index].type) &&  ['state', undefined].includes(listType[index - 1])) ? true : false;
      return (
        <li
          key={item.uid ?? key++}
          className={`item-timeline ${['comments', 'attachments'].includes(item.type) ? 'item-timeline-avatar' : 'item-status'} ${isCheckLastDotItem ? 'item-last-dot' : ''} ${isCheckFirstDotItem ? 'item-first-dot' : ''}`}
        >
          <div className={`inner ${['comments', 'attachments'].includes(item.type) ? 'inner-dot' : ''}`}>

            {['comments', 'attachments'].includes(item.type) ?
              <div className='content-block'>
                {currentUser.name === item.createdByUserName && !!currentUser.photo ?
                  <div className='sb-avatar has-avatar'>
                    <img src={currentUser.photo} alt="avatar" title="Avatar" id="img-timeline-avatar" />
                  </div>
                  :
                  <Avatar 
                    {...stringAvatar(item.createdByUserName === currentUser.name ? currentUser.avatar_name : item.createdByUserName, 30, theme.uptimeColors?.ticketColors?.chatTimeline?.other?.iconColor)}
                    className='sb-avatar'
                    imgProps={{
                      id: "img-timeline-avatar"
                    }}
                  />
                }
                <p className="content-header">
                  <span className={`name ${currentUser.name !== item.createdByUserName ? 'color-agent' : ''}`} id="lbl-timeline-created_by_user_name">{item.createdByUserName}</span>
                  <span className='date' id="lbl-timeline-created_date">{item.createdDate}</span>
                </p>
                <div className='content-body'>
                  {item.type === 'comments' ?
                    <TextareaAutosize readOnly className="txt-comment" id="lbl-timeline-comment" aria-label="Timeline Comment">{item.value}</TextareaAutosize>
                    :
                    <ul className="att-file">
                      <li>
                        <FileDocumentIcon alt="icon-document" />
                        <span className='file-name'>{item.fileName} <AttachFileIcon id="img-tineline-attach_file"/></span>
                      </li>
                    </ul>
                  }
                </div>
              </div>
              :
              <div className='content-block content-only-status'>
                <p className="content-header">
                  <span className="name">{locale?.ticketStatus} {locale?.commonStatus[item?.value?.toUpperCase()]}</span>
                  <span className='date' id="lbl-timeline-created_date">{item.createdDate}</span>
                </p>
              </div>
            }

          </div>
        </li>
      );
    });

    return result;
  }

  return (
    <StyledTimeLineSection>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className="timeline-header"
        >
          <Typography className="ttl-time show-time">
            {locale?.showTimeline}
          </Typography>

          <Typography className="ttl-time hide-time">
            {locale?.hideTimeline}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="acc-detail">
          <Timeline align="alternate">
            <li
              className={`content-init-created ${
                data?.activities?.length === 0 ? "content-created-only" : ""
              }`}
            >
              <div className="content-body">
                <Grid container className="tb-header">
                  <Grid item xs={6}>
                    {locale?.ticketNumber}
                  </Grid>
                  <Grid item xs={6}>
                    {locale?.created}
                  </Grid>
                </Grid>
                <Grid container className="tb-body">
                  <Grid item xs={6} id='lbl-ticket-number'>
                    {data?.item?.number}
                  </Grid>
                  <Grid item xs={6} id='lbl-ticket-created_date'>
                    {createdDateInit}
                  </Grid>
                </Grid>
              </div>
            </li>
            {data?.activities?.length > 0 && showTimeLine(data?.activities)}
          </Timeline>
          {isLoading && <CircularProgress className="isLoadingTimeLine" />}
        </AccordionDetails>
      </Accordion>
    </StyledTimeLineSection>
  );
};

TimeLine.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.object,
  currentUser: PropTypes.object,
  createdDateInit: PropTypes.string,
  locale: PropTypes.object,
};

TimeLine.defaultProps = {
  createdDateInit: '50 days ago',
  isLoading: false,
  data: {
    item: {
      uid: "8b139b88dbfe741018e16462ca961960",
      number: "INC0010391",
      createdDate: "2021-09-20 07:47:59",
      createdBy: "bnguyen42@dxc.com",
      createdByUserName: "Cong Bang Nguyen",
      type: "added",
    },
    activities: [
      {
        uid: "2c2fe3a587fd85102df40fee8bbb3584",
        createdDate: "2022-02-21 04:48:37",
        createdBy: "hhuynh30@dxc.com",
        createdByUserName: "Tu Hai Huynh",
        type: "comments",
        value: "haha",
        oldValue: "",
      },
      {
        uid: "cdafc056db54c55018e16462ca961986",
        createdDate: "2021-12-10 06:53:26",
        createdBy: "hhuynh30@dxc.com",
        createdByUserName: "Tu Hai Huynh",
        type: "comments",
        value: "reopen 391",
        oldValue: "",
      },
      {
        uid: "b4af885adb9cc510bf85ce1c299619c5",
        createdDate: "2021-12-10 06:53:25",
        createdBy: "uptime.user",
        createdByUserName: "uptime.user",
        type: "state",
        value: "In Progress",
        oldValue: "Resolved",
      },
      {
        uid: "908f8056db54c55018e16462ca96193f",
        createdDate: "2021-12-10 06:52:50",
        createdBy: "hhuynh30@dxc.com",
        createdByUserName: "Tu Hai Huynh",
        type: "comments",
        value: "391",
        oldValue: "",
      },
      {
        uid: "0c8f845adb9cc510bf85ce1c299619e7",
        createdDate: "2021-12-10 06:52:50",
        createdBy: "uptime.user",
        createdByUserName: "uptime.user",
        type: "state",
        value: "Resolved",
        oldValue: "In Progress",
      },
      {
        uid: "c75f0056db54c55018e16462ca961966",
        createdDate: "2021-12-10 06:52:12",
        createdBy: "hhuynh30@dxc.com",
        createdByUserName: "Tu Hai Huynh",
        type: "comments",
        value: "test",
        oldValue: "",
      },
      {
        uid: "2bb2930adb90c55018e16462ca9619e5",
        createdDate: "2021-12-10 02:27:22",
        createdBy: "hhuynh30@dxc.com",
        createdByUserName: "Tu Hai Huynh",
        type: "comments",
        value: "def",
        oldValue: "",
      },
      {
        uid: "6bb2db0adb90c55018e16462ca961904",
        createdDate: "2021-12-10 02:27:21",
        createdBy: "uptime.user",
        createdByUserName: "uptime.user",
        type: "state",
        value: "In Progress",
        oldValue: "Resolved",
      },
      {
        uid: "e6f1938edbd8c510bf85ce1c2996196c",
        createdDate: "2021-12-10 02:24:01",
        createdBy: "hhuynh30@dxc.com",
        createdByUserName: "Tu Hai Huynh",
        type: "comments",
        value: "abc",
        oldValue: "",
      },
    ],
  },
  currentUser: {
    uid: "2b6e78dedbe23010bf85ce1c29961928",
    name: "Tu Hai Huynh",
    user_name: "hhuynh30@dxc.com",
    phone: "",
    first_name: "Tu Hai",
    last_name: "Huynh",
    employee_number: "11575597",
    vip: "false",
    photo: "",
    mobile_phone: "",
    avatar_name: "Hai Huynh",
    city: "Ho Chi Minh City",
    state: "SG",
    country: "VNM",
    department: "2601 DXC Technology Services Vietnam Company Ltd",
    manager_email: "qpham7@dxc.com",
    manager_name: "Minh Quoc Pham",
    location: "5 Building 364 Cong Hoa, Ho Ch",
    locationId: "c38d1cbedb16b85018e16462ca9619c6",
    email: "hhuynh30@dxc.com",
    address: "364 Cong Hoa\nTan Binh District Ho Chi Minh City SG 700000 VNM",
    altCompanyCode: "DXC Technology",
    cscCountry: "VNM",
    cscCountry2: "VN",
    cscUserType: "EMP",
  },
  locale: {
    "ticketStatus": "Ticket Status:",
    "showTimeline": "Show Timeline",
    "hideTimeline": "Hide Timeline",
    "ticketNumber": "Ticket Number",
    "created": "Created",
    commonStatus: {
      "Open": "Open",
      "open": "Open",
      "Reopen": "Reopen",
      "closed": "Closed",
      "Closed": "Closed",
      "Resolved": "Resolved",
      "submitted": "Submitted",
      "cancelled": "Cancelled",
      "Cancelled": "Cancelled",
      "In Progress": "In Progress",
      "requested": "Requested",
      "Requested": "Requested",
      "Awaiting Approval": "AWAITING APPROVAL",
      "Rejected": "REJECTED",
      "No Longer Required": "NO LONGER REQUIRED",
      "Preparing Device": "PREPARING DEVICE",
      "Action Required": "Action Required",
      "Approved": "Approved",
      "Device in Transit":"Device in Transit",
      "Approval Rejected": "APPROVAL REJECTED",
      "Under Investigation": "UNDER INVESTIGATION"
    }
  },
};

export default TimeLine;
